import React, { useContext, useEffect, useState } from 'react';
import { ScreensContext } from '../contexts/screensContext';
import styles from '../components/lm-d-s/index.module.scss';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import CharacteristicScreen from '../components/lm-d-s/characteristic-screen';
import FinalScreen from '../components/kv/final-screen';
import WelcomeScreen from '../components/kv/welcome-screen';
import CommerceVideoScreen from '../components/commerce-video-screen/CommerceVideoScreen';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import { getImageFromS3 } from '../imageService';
import useScreenHistory from '../hooks/useScreenHistory';

const KV = () => {
  const { screenNumber, setScreenNumber } = useScreenHistory({
    initialScreen: 0
  });
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [selectedPack, setSelectedPack] = useState(null);

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  useEffect(() => {
    init('KV');
    sendEvent('age_verification_without');
  }, [init]);

  const handleSelectPack = (pack) => {
    setSelectedPack(pack);
    setScreenNumber(2);
  };

  const getScreen = (number, cb) => {
    switch (number) {
      case 0: {
        return (
          <CommerceVideoScreen
            videoSrc={getImageFromS3('videos/kv-video.mp4')}
            setScreenNumber={cb}
            nextScreenNumber={1}
            changeScreenImmediately
            skipScreenImmediately
            controls
            buttonStyle="skip-video"
            hasButtonArrow
          />
        );
      }
      case 1: {
        return (
          <WelcomeScreen
            setScreenNumber={cb}
            backgroundImage={`url("${getImageFromS3(
              'images/lm-l-green/background.png'
            )}")`}
            handleNextButton={() => setScreenNumber(3)}
            handlePackSelect={handleSelectPack}
          />
        );
      }
      case 2: {
        return (
          <CharacteristicScreen
            brandId="lm"
            isKV={selectedPack?.isKV}
            isNewMixture={selectedPack?.isNewMixture}
            title={selectedPack?.title}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={selectedPack?.filterCharacteristicList}
            infoList={selectedPack?.characteristicInfoList}
            tobaccoFirst={selectedPack?.tobaccoFirst}
            tobaccoSecond={selectedPack?.tobaccoSecond}
            packImage={selectedPack?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(3)}
            backgroundImage={selectedPack?.background}
            filterIcon={selectedPack?.filterIcon}
            nextButtonTitle="Далі"
          />
        );
      }
      case 3: {
        return (
          <FinalScreen
            setScreenNumber={cb}
            handleBackButton={() => setScreenNumber(1, true)}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };
  return (
    <div className={styles.pageContainer} id="kv-screen-container">
      <div className={styles.contentContainer}>
        <ScreensContext.Provider
          value={{
            endSessionType,
            setEndSessionType,
            isDisplayedAll,
            setIsDisplayedAll
          }}
        >
          {getScreen(screenNumber, setScreenNumber)}
        </ScreensContext.Provider>
      </div>
    </div>
  );
};

export default KV;
